import PointsSlider from './PointsSlider';

export default PointsSlider;
